import useVendorService from '../useVendorService';
import { useVendorId } from '../routes';
import SingleVendorBreadcrumbs from '../shared/SingleVendorBreadcrumbs';
import { FormShowTemplate, CountryBadge } from 'framework/form';
import { DEFAULT_ENTITY_AUTHOR } from 'domain/shared/core/constants';
import ComplianceVendorButton from '../shared/buttons/ComplianceVendorButton';
import AgreementVendorButton from '../shared/buttons/AgreementVendorButton';
import { Box } from '@mui/material';
import VendorCompliantBadge from '../shared/fields/VendorCompliantBadge';
import VendorProfileStatusBadge from '../shared/fields/VendorProfileStatusBadge';
import { EntityHeader, EntityProfileLayout, ShowPageLayout } from 'framework/ui/layout';
import { Tooltip } from 'framework/ui/mui-builder';
import PrivacyTipIcon from '@mui/icons-material/PrivacyTip';
import RejectVendorButton from '../shared/buttons/RejectVendorButton';
import VendorProfileLayout from './VendorProfileLayout';
import VendorTabsSection from '../VendorTabs/VendorTabsSection';
import VendorWorkingStatusBadge from '../shared/fields/VendorWorkingStatusBadge';

const VendorProfile = () => {
  const id = useVendorId()!;
  const { getById, update, getEditVendorValidationSchema } = useVendorService();

  return (
    <FormShowTemplate
      getDataFunc={async () => getById(id, true)}
      getValidationSchemaFunc={getEditVendorValidationSchema}
      submitFormFunc={async editData => update(id, editData)}
    >
      <ShowPageLayout
        entityHeader={
          <EntityHeader
            entityTitleSource="vendorName"
            defaultAuthor={DEFAULT_ENTITY_AUTHOR}
            badges={(data: any) => {
              // TODO add Type DTO
              return (
                <Box display="flex" alignItems="center">
                  <VendorProfileStatusBadge status={data.profileStatus} />
                  <VendorWorkingStatusBadge status={data.workingStatus} />
                  <VendorCompliantBadge isCompliant={data.isCompliant} />
                  <Tooltip title={data?.country}>
                    <span>
                      <Box display="flex" ml="3px">
                        <CountryBadge country={data?.country} />
                      </Box>
                    </span>
                  </Tooltip>
                  {data.isDataProcessor ? (
                    <Tooltip title="Data processor">
                      <span>
                        <Box display="flex" ml="3px">
                          <PrivacyTipIcon color="primary" />
                        </Box>
                      </span>
                    </Tooltip>
                  ) : null}
                </Box>
              );
            }}
          />
        }
        headerButtons={[<ComplianceVendorButton />, <AgreementVendorButton />, <RejectVendorButton />]}
        breadcrumbs={<SingleVendorBreadcrumbs />}
        hasSeparateSections
      >
        <EntityProfileLayout leftColumnElement={<VendorProfileLayout />} rightColumnElement={<VendorTabsSection />} />
      </ShowPageLayout>
    </FormShowTemplate>
  );
};

export default VendorProfile;
